var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      class: [_vm.computedClass, _vm.className],
      attrs: { disabled: _vm.isLoading || _vm.disabled },
      on: { click: _vm.handleClick }
    },
    [
      _vm.isLoading ? _c("span", { staticClass: "loader" }) : _vm._e(),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }